/* Brillare Landing Page Commerce — reusable, product-agnostic.
 * Configuration belongs ONLY in Page HTML via data-br-* attributes.
 * Displays live price, compare-at price, and % savings without hardcoded prices.
 * Uses the existing Shopify storefront/cart and adds no duplicate pixels.
 * One Add-to-Cart request per click; failures never auto-retry.
 */
(function () {
  'use strict';
  var productCache = new Map();

  function basePath() {
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return route.endsWith('/') ? route : route + '/';
  }
  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    var locale = (window.Shopify && window.Shopify.locale) || 'en-IN';
    try { return new Intl.NumberFormat(locale, { style:'currency', currency:currency }).format(Number(cents)/100); }
    catch (_) { return '₹' + (Number(cents)/100).toFixed(2); }
  }
  function validID(id) {
    return /^\d+$/.test(String(id || '')) && Number.isSafeInteger(Number(id)) && Number(id) > 0;
  }
  function positiveQuantity(value) {
    var n = Number(value);
    return Number.isSafeInteger(n) && n > 0 ? n : null;
  }
  function getProduct(handle) {
    if (!handle) return Promise.reject(new Error('Missing product handle in HTML (data-br-product-handle).'));
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(basePath() + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials:'same-origin', headers:{Accept:'application/json'}
      }).then(function (r) {
        if (!r.ok) throw new Error('Product "' + handle + '" unavailable (' + r.status + ')');
        return r.json();
      }));
    }
    return productCache.get(handle);
  }
  function readItems(radio, root) {
    // Optional multi-item bundles use data-br-items='[{"id":"...","quantity":1,"handle":"..."}, ...]'.
    var bundle = radio.getAttribute('data-br-items');
    var fallbackHandle = radio.getAttribute('data-br-product-handle') || root.getAttribute('data-br-product-handle') || '';
    var list;
    if (bundle) {
      try { list = JSON.parse(bundle); }
      catch (_) { throw new Error('Invalid data-br-items JSON in landing page HTML.'); }
    } else {
      list = [{
        id: radio.getAttribute('data-br-variant-id') || root.getAttribute('data-br-variant-id'),
        quantity: radio.getAttribute('data-br-quantity') || '1',
        handle: fallbackHandle
      }];
    }
    if (!Array.isArray(list) || !list.length) throw new Error('No products configured for this offer.');
    return list.map(function (item) {
      var id = String(item.id || item.variant_id || '');
      var qty = positiveQuantity(item.quantity);
      var handle = String(item.handle || item.product_handle || fallbackHandle || '');
      if (!validID(id)) throw new Error('Invalid variant ID in page HTML: ' + id);
      if (qty === null) throw new Error('Invalid offer quantity in page HTML.');
      if (!handle) throw new Error('Add data-br-product-handle to the page HTML.');
      return { id:id, quantity:qty, handle:handle };
    });
  }
  function statusText(node, message, isError) {
    if (!node) return;
    node.textContent = message || '';
    node.style.color = isError ? '#a02f33' : '#245441';
  }

  function updateSectionElement(element, html) {
    if (!element || !html || typeof html !== 'string') return false;
    var newSection = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (!newSection) return false;
    element.innerHTML = newSection.innerHTML;
    return true;
  }
  async function refreshNativeCart() {
    var miniCart = document.querySelector('mini-cart');
    var root = basePath();
    if (!miniCart) return false;
    try {
      var names = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
      var res = await fetch(root + '?sections=' + names.join(','), { credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'} });
      if (!res.ok) throw new Error('Sections request ' + res.status);
      var sections = await res.json();
      if (!updateSectionElement(miniCart, sections['mini-cart'])) throw new Error('Empty mini-cart section');
      names.slice(1).forEach(function (key) { updateSectionElement(document.getElementById(key), sections[key]); });
      return true;
    } catch (error) { console.warn('[Brillare Landing] Cart sections fallback:', error); }
    try {
      var res2 = await fetch(root + '?section_id=mini-cart', { credentials:'same-origin', cache:'no-store' });
      if (!res2.ok) throw new Error('Cart section ' + res2.status);
      return updateSectionElement(miniCart, await res2.text());
    } catch (error) {
      console.warn('[Brillare Landing] Could not refresh native cart:', error);
      return false;
    }
  }
  function openNativeCart() {
    try {
      var controller = document.querySelector('cart-drawer');
      if (controller && typeof controller.openMenuDrawer === 'function') {
        controller.openMenuDrawer(); return true;
      }
      var details = document.querySelector('details.cart-drawer-container');
      if (!details || !document.querySelector('mini-cart')) return false;
      details.setAttribute('open', '');
      details.classList.add('menu-opening');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
      document.body.classList.remove('mini-cart--closing','mini-cart--opening');
      document.body.classList.add('mini-cart--open');
      if (!details.dataset.brLandingCloseBound) {
        details.dataset.brLandingCloseBound = '1';
        var close = function () {
          details.removeAttribute('open'); details.classList.remove('menu-opening');
          if (summary) summary.setAttribute('aria-expanded','false');
          document.body.classList.remove('mini-cart--open','mini-cart--opening','mini-cart--closing');
        };
        details.addEventListener('click', function (event) {
          if (event.target.closest('drawer-close-button')) { event.preventDefault(); close(); }
        });
        document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && details.open) close(); });
      }
      return true;
    } catch (error) { console.warn('[Brillare Landing] Drawer open failed:', error); return false; }
  }

  // Generic offer-price UI; sale pricing is always derived from Shopify variant data.
  function salePercentage(compare, price) {
    if (!(compare > price && price >= 0)) return 0;
    // Ceiling matches the common Shopify theme badge convention.
    return Math.ceil(((compare - price) * 100) / compare);
  }
  function showOfferPrice(node, record) {
    if (!node) return;
    if (!node.querySelector('[data-br-offer-current]')) {
      // Backward compatible with existing HTML: the Page only needs data-br-offer-price.
      node.replaceChildren();
      var current = document.createElement('strong');
      current.setAttribute('data-br-offer-current', '');
      var original = document.createElement('s');
      original.setAttribute('data-br-offer-original', '');
      original.hidden = true;
      var badge = document.createElement('span');
      badge.setAttribute('data-br-offer-discount', '');
      badge.hidden = true;
      node.append(current, original, badge);
    }
    var currentNode = node.querySelector('[data-br-offer-current]');
    var originalNode = node.querySelector('[data-br-offer-original]');
    var badgeNode = node.querySelector('[data-br-offer-discount]');
    var ready = !!(record && record.ready);
    currentNode.textContent = ready ? money(record.price) : (record && record.error ? 'Unavailable' : 'Loading…');
    var onSale = ready && Number.isFinite(record.compare) && record.compare > record.price;
    originalNode.hidden = !onSale;
    badgeNode.hidden = !onSale;
    originalNode.textContent = onSale ? money(record.compare) : '';
    badgeNode.textContent = onSale ? 'SAVE ' + salePercentage(record.compare, record.price) + '%' : '';
  }

  function init(root, index) {
    if (root.dataset.brCommerceReady) return;
    root.dataset.brCommerceReady = '1';
    var offers = Array.from(root.querySelectorAll('input[type="radio"][data-br-quantity], input[type="radio"][data-br-variant-id], input[type="radio"][data-br-items]'));
    var buy = root.querySelector('[data-br-buy]');
    var label = root.querySelector('[data-br-buy-label]') || buy;
    var total = root.querySelector('[data-br-selected-price]');
    var compare = root.querySelector('[data-br-compare-price]');
    var savings = root.querySelector('[data-br-selected-savings]');
    var note = root.querySelector('[data-br-price-note]');
    var status = root.querySelector('[data-br-cart-status]');
    if (!offers.length || !buy) {
      console.warn('[Brillare Landing] Commerce HTML missing offers or buy button.');
      return;
    }
    if (!offers.some(function(r){return r.checked;})) offers[0].checked = true;
    var records = new Map();
    var submitting = false;
    var debug = {
      version:'dynamic-html-v2-sale-pricing', concept:root.getAttribute('data-br-concept') || '', state:'loading',
      storefront:location.hostname, offers:[], currentItems:[], lastHTTPStatus:null
    };
    window.BrillareLandingCommerceDebug = debug;
    function chosenRadio() { return offers.find(function(r){return r.checked;}) || offers[0]; }
    function selectedRecord() { return records.get(chosenRadio()); }
    function render() {
      offers.forEach(function (radio) {
        var record = records.get(radio);
        var offerElement = radio.closest('[data-br-offer]');
        var priceEl = offerElement && offerElement.querySelector('[data-br-offer-price]');
        showOfferPrice(priceEl, record);
      });
      var record = selectedRecord();
      if (record && record.ready) {
        if (total) total.textContent = money(record.price);
        if (compare) {
          compare.hidden = !(record.compare > record.price);
          compare.textContent = record.compare > record.price ? money(record.compare) : '';
        }
        if (savings) {
          var discounted = record.compare > record.price;
          savings.hidden = !discounted;
          savings.textContent = discounted ? 'You save ' + money(record.compare - record.price) + ' (' + salePercentage(record.compare, record.price) + '%)' : '';
        }
        if (label) label.textContent = submitting ? 'ADDING TO CART…' : 'ADD TO CART · ' + money(record.price);
        buy.disabled = submitting;
        if (note) note.textContent = 'Eligible discounts and final totals are calculated by Shopify in the cart.';
        if (!submitting && !['drawer-open','added-drawer-unavailable','add-failed','added-drawer-error'].includes(debug.state)) statusText(status, '');
        debug.currentItems = record.items.map(function (i) { return {id:i.id,quantity:i.quantity}; });
        debug.state = submitting ? 'adding' : (['drawer-open','added-drawer-unavailable','add-failed','added-drawer-error'].includes(debug.state) ? debug.state : 'ready');
      } else {
        if (total) total.textContent = record?.error ? 'Offer unavailable' : 'Loading…';
        if (compare) compare.hidden = true;
        if (savings) savings.hidden = true;
        if (label) label.textContent = record?.error ? 'OFFER UNAVAILABLE' : 'LOADING LIVE PRICES…';
        buy.disabled = true;
        if (record?.error) { statusText(status, record.error, true); debug.state='invalid-offer'; }
      }
    }
    offers.forEach(function (radio) {
      radio.addEventListener('change', function () {
        debug.state='ready'; statusText(status,'');
        render();
        var record = selectedRecord();
        root.dispatchEvent(new CustomEvent('brillare:offer_selected', {
          bubbles:true, detail:{concept:debug.concept,items:record?.items?.map(function(i){return {id:i.id,quantity:i.quantity};}) || []}
        }));
      });
    });
    buy.disabled = true;
    offers.forEach(async function (radio, pos) {
      try {
        var items = readItems(radio, root);
        var resolved = await Promise.all(items.map(async function (item) {
          var product = await getProduct(item.handle);
          var v = (product.variants || []).find(function (variant) { return String(variant.id) === item.id; });
          if (!v) throw new Error('Variant ' + item.id + ' not found in Shopify product "' + item.handle + '". Check the ID in this page’s HTML.');
          if (!v.available) throw new Error('Selected product variant is out of stock.');
          if (v.requires_selling_plan) throw new Error('This variant requires a selling plan; configure it before using this funnel.');
          return {id:item.id,quantity:item.quantity,price:Number(v.price),compare:Number(v.compare_at_price || 0)};
        }));
        records.set(radio, {
          ready:true, items:items, price:resolved.reduce(function(s,x){return s+x.price*x.quantity;},0),
          compare:resolved.reduce(function(s,x){return s+(x.compare||x.price)*x.quantity;},0)
        });
        debug.offers[pos]={state:'ready',items:items.map(function(x){return {id:x.id,quantity:x.quantity};})};
      } catch (err) {
        records.set(radio, {ready:false,error:err.message,items:[]});
        debug.offers[pos]={state:'error',reason:err.message};
      }
      render();
    });
    render();

    buy.addEventListener('click', async function (event) {
      event.preventDefault();
      event.stopPropagation();
      var record = selectedRecord();
      if (submitting || !record || !record.ready) return;
      submitting = true; render();
      statusText(status,'Adding to your Shopify cart…');
      debug.state='requesting'; debug.lastHTTPStatus=null;
      var added = false;
      try {
        // No theme-interceptable product form. Shopify is called exactly once per Buy click.
        var res = await fetch(basePath() + 'cart/add.js', {
          method:'POST', credentials:'same-origin',
          headers:{Accept:'application/json','Content-Type':'application/json'},
          body:JSON.stringify({items:record.items.map(function(i){return {id:Number(i.id),quantity:i.quantity};})})
        });
        debug.lastHTTPStatus=res.status;
        var payload = await res.json().catch(function(){return {};});
        if (!res.ok || payload.status >= 400) throw new Error(payload.description || payload.message || 'Shopify rejected the request (' + res.status + ').');
        added = true; debug.state='added';
        document.dispatchEvent(new CustomEvent('brillare:cart_added', {
          bubbles:true, detail:{concept:debug.concept,items:record.items.map(function(i){return {id:i.id,quantity:i.quantity};})}
        }));
        // GoKwik primary; native Shopify cart fallback.
var opened = false;
var cartProvider = 'none';

debug.drawerRefreshed = false;
debug.drawerOpened = false;

try {
  if (typeof window.openGokwikSideCart !== 'function') {
    throw new Error('GoKwik opener unavailable');
  }

  // Do not add the product again.
  // Shopify /cart/add.js already succeeded above.
  await Promise.resolve(window.openGokwikSideCart());

  opened = true;
  cartProvider = 'gokwik';

} catch (gokwikError) {
  console.warn(
    '[Brillare Landing] GoKwik unavailable:',
    gokwikError
  );

  // Fall back to the original native Shopify cart.
  var refreshed = await refreshNativeCart();
  debug.drawerRefreshed = refreshed;

  opened = refreshed && openNativeCart();
  cartProvider = opened ? 'native' : 'none';
}

debug.drawerOpened = opened;
debug.cartProvider = cartProvider;

debug.state = opened
  ? 'drawer-open'
  : 'added-drawer-unavailable';

statusText(
  status,
  opened
    ? 'Added to your cart.'
    : 'Added to Shopify cart. Please use the cart icon.',
  !opened
);
      } catch (err) {
        debug.state=added?'added-drawer-error':'add-failed'; debug.error=String(err.message||err);
        console.error('[Brillare Landing] Cart:',err);
        statusText(status,(added?'Added, but drawer error: ':'Could not add to cart: ')+(err.message||'Unknown error'),true);
      } finally { submitting=false; render(); }
    });
  }
  function initAll() { document.querySelectorAll('[data-br-commerce]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
